import { render, staticRenderFns } from "./DeleteMachineStatusRules.vue?vue&type=template&id=f883e846"
import script from "./DeleteMachineStatusRules.vue?vue&type=script&lang=js"
export * from "./DeleteMachineStatusRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports